export const OffersChartColor = ['#0096ff', '#2BC04C', '#f0c916', '#D83B01', '#0017FF'];

export const GetRegistrationCountColor = ['#0096ff', '#2BC04C', '#f0c916', '#D83B01'];

export const CompanyCandidateRatingColor = ['#2BC04C', '#d83b01'];

export const FeedbackColor = ['#2BC04C', '#0096ff', '#0017FF', '#f0c916', '#d83b01'];

export const LoginStatusColors = ['#2BC04C', '#0096ff', '#f0c916', '#808080'];
